import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface VacationEntry {
  id: number;
  employeeId: string;
  employeeName: string;
  fromDate: string;
  toDate: string;
  numOfDays: number;
  reasonForVacation: string;
  emergencyContact: string;
  status: 'pending' | 'approved' | 'rejected';
  userId: number;
  createdDate: number;
}

export interface CreateVacationRequest {
  employeeId: string;
  employeeName: string;
  fromDate: string;
  toDate: string;
  numOfDays?: number;
  reasonForVacation: string;
  emergencyContact: string;
}

export interface PaginatedVacationResponse {
  data: VacationEntry[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const vacationApi = {
  getAll: (params: { page?: number; limit?: number }, token: string): Promise<PaginatedVacationResponse> => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page.toString());
    if (params.limit) q.append('limit', params.limit.toString());
    return apiRequest<PaginatedVacationResponse>(
      `${buildApiUrl(API_CONFIG.ENDPOINTS.VACATION.BASE)}?${q}`,
      { method: 'GET', headers: getAuthHeaders(token) }
    );
  },

  create: (data: CreateVacationRequest, token: string): Promise<VacationEntry> =>
    apiRequest<VacationEntry>(buildApiUrl(API_CONFIG.ENDPOINTS.VACATION.BASE), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  update: (id: number, data: Partial<CreateVacationRequest>, token: string): Promise<VacationEntry> =>
    apiRequest<VacationEntry>(buildApiUrl(API_CONFIG.ENDPOINTS.VACATION.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  updateStatus: (id: number, status: 'pending' | 'approved' | 'rejected', token: string): Promise<VacationEntry> =>
    apiRequest<VacationEntry>(buildApiUrl(API_CONFIG.ENDPOINTS.VACATION.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify({ status }),
    }),

  remove: (id: number, token: string): Promise<void> =>
    apiRequest<void>(buildApiUrl(API_CONFIG.ENDPOINTS.VACATION.BY_ID(id)), {
      method: 'DELETE',
      headers: getAuthHeaders(token),
    }),
};
